import { render, staticRenderFns } from "./vhtml.vue?vue&type=template&id=0ea51fb4"
import script from "./vhtml.vue?vue&type=script&lang=js"
export * from "./vhtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports